import React from 'react';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {Button, type ExportData, ExportType} from '@forecast-it/design-system';

interface ExpenseManagementExportButtonProps {
	exportData: ExportData;
	includeColumns: string[];
}

export const ExpenseManagementExportButton = ({
	exportData,
	includeColumns,
}: ExpenseManagementExportButtonProps): JSX.Element => {
	const onExportCsv = () => {
		trackEvent('CSV File', 'Exported');
		exportData('financials-breakdown', ExportType.CSV, includeColumns);
	};
	return <Button emphasis={'medium'} icon={'download'} onPress={onExportCsv} data-cy={'export-expenses-csv'}></Button>;
};

export default ExpenseManagementExportButton;
